import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { SessionInfo } from '../modal';

export default function reducer(state: SessionInfo = new SessionInfo(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SESSION_INFO_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SESSION_INFO_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SESSION_INFO_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
